export default __webpack_public_path__ + "static/media/icon-trashcan.33a01fb7.svg";